import(/* webpackMode: "eager" */ "/workspace/app/[locale]/ai-career/page.tsx");
